import { Color } from '@coast/schemas';
import React from 'react';
import { StyleProp, StyleSheet, TextStyle, ViewStyle } from 'react-native';
import { Tag } from '@shared/components/blocks/lib/tags/tag';
import { Pill } from '@shared/components/pill';
import { TagField } from '@shared/data/entity/fields/TagField';
import { Colors, grid } from '@shared/styles';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

const MAX_TAGS_TO_SHOW = 3;

interface Props {
  field: TagField;
  style?: StyleProp<ViewStyle>;
  tagItemStyle?: StyleProp<ViewStyle>;
  tagTextStyle?: StyleProp<TextStyle>;
}

const styles = StyleSheet.create({
  tagList: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginLeft: -grid(0.5),
    alignItems: 'center',
  },
});

export function TagCollectionViewField({ field, style, tagItemStyle, tagTextStyle }: Props) {
  if (field.isEmpty) {
    return null;
  }

  const visibleTagValues = field.tagIds.slice(0, MAX_TAGS_TO_SHOW);
  const remainingTagCount = field.tagIds.length - visibleTagValues.length;
  const visibleTags = field.tagOptions.filter(tag => visibleTagValues.includes(tag.value));

  return (
    <CardCollectionViewFieldContainer style={[styles.tagList, style]}>
      {visibleTags.map(tag => (
        <Tag
          key={tag.value}
          color={tag.backgroundColor as Color}
          archived={!!tag.archived}
          style={tagItemStyle}
          textStyle={tagTextStyle}
          label={tag.label}
        />
      ))}
      {remainingTagCount > 0 && (
        <Pill
          round
          noBorder
          backgroundColor={Colors.v2.transparent as Color}
          style={tagItemStyle}
          textStyle={tagTextStyle}
          sections={[`+${remainingTagCount}`]}
        />
      )}
    </CardCollectionViewFieldContainer>
  );
}
